import LessonsBlock from './LessonsBlock.vue';

export default LessonsBlock;



// WEBPACK FOOTER //
// ./src/pages/profile/components/info/components/block/components/legend/components/lessonsblock/index.ts